module.exports = __webpack_public_path__ + "media/images/icn-user-e385081e30e392b2a32c54ee1899f642.png";